import { defineMessages } from "react-intl";

export const ProductBladeLabels = defineMessages({
  productNotFound: {
    id: "transfers.create.productBlade.productNotFound",
    defaultMessage: "Product not found",
  },
  insufficientInventory: {
    id: "transfers.create.productBlade.insufficientInventory",
    defaultMessage: "Insufficient inventory",
  },
  casePackNotFound: {
    id: "transfers.create.productBlade.casePackNotFound",
    defaultMessage: "Case pack not found",
  },
  casePackNotFoundWithExpected: {
    id: "transfers.create.productBlade.casePackNotFoundWithExpected",
    defaultMessage: "Case pack of {expectedCasePack} not found",
  },
  multipleMatchingDskus: {
    id: "transfers.create.productBlade.multipleMatchingDskus",
    defaultMessage: "Multiple matching DSKUs found",
  },
  lotNotFound: {
    id: "transfers.create.productBlade.lotNotFound",
    defaultMessage: "Lot number not found",
  },
  productIssueDetected: {
    id: "transfers.create.productBlade.productIssueDetected",
    defaultMessage: "Product issue detected",
  },
});
